import { StagedMatterFilesDialog } from '@/matter-asset-common/files/components/StagedMatterFilesDialog'
import type { ComponentProps } from 'react'

export function AddFilesMatterFilesDialog(props: ComponentProps<typeof StagedMatterFilesDialog>) {
  return <StagedMatterFilesDialog {...props} />
}
